"use client";

import React, { useState, useEffect, useRef } from 'react';
import { FaPhoneAlt, FaWhatsapp, FaTooth, FaStethoscope, FaCrown, FaSmile, FaMagic, FaChild, FaSyringe, FaTint, FaLeaf, FaWrench, FaGrin, FaAmbulance } from 'react-icons/fa';
import clinicLogo from '../../assets/logo.png';
import clinicBg from '../../assets/about/clinic/1.JPG';
import mastermindLogo from '../../assets/mm.png';
import shahImg from '../../assets/about/shah.jpeg';
import Testimonial from '../../components/Testimonial/Testimonial';

export default function PPC2() {
  const [formSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [year, setYear] = useState('');

  const galRef = useRef(null);
  const [treatmentOpen, setTreatmentOpen] = useState(false);
  const [selectedTreatment, setSelectedTreatment] = useState("");

  const treatments = [
    "Dental Implants",
    "Painless Root Canal (RCT)",
    "Crowns & Bridges",
    "Braces & Aligners",
    "Whitening & Veneers",
    "Teeth Cleaning",
    "Wisdom Tooth Removal",
    "Full Mouth Rehab",
    "Kids & Family Dentistry",
    "Smile Designing",
    "Dentures",
    "Emergency / pain",
    "Not sure — need advice"
  ];


  const scrollGal = (dir) => {
    if (galRef.current) {
      const scrollAmount = dir === 'left' ? -300 : 300;
      galRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    setYear(new Date().getFullYear().toString());
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const name = formData.get('name') || '';
    const phone = formData.get('phone') || '';
    if (!name.trim() || !phone.trim()) {
      alert('Please add your name and number.');
      return;
    }

    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(name.trim())) {
      alert('Please enter a valid name (letters only).');
      return;
    }

    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(phone.trim())) {
      alert('Please enter a valid 10-digit phone number.');
      return;
    }

    // Prepare WhatsApp message
    const waMessage = `Hi, I'd like to book a dental appointment.\n\nName: ${name.toString().trim()}\nPhone: ${phone.toString().trim()}\nTreatment: ${selectedTreatment || 'General Inquiry'}\n\n(Lead from PPC2 Landing Page)`;
    const whatsappUrl = `https://wa.me/919035289171?text=${encodeURIComponent(waMessage)}`;

    // Open WhatsApp synchronously to prevent popup blocker
    window.open(whatsappUrl, '_blank');

    setIsSubmitting(true);
    try {
      await fetch('/api/ppc2form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: name.toString().trim(),
          mobile: phone.toString().trim(),
          interest: selectedTreatment || 'General Inquiry',
          message: 'Lead from PPC2 Landing Page'
        }),
      });
    } catch (error) {
      console.error('API error:', error);
    } finally {
      window.location.href = `/thankyou?source=${encodeURIComponent(window.location.pathname)}`;
    }
  };

  return (
    <>


      <style dangerouslySetInnerHTML={{
        __html: `
          @import url('https://fonts.googleapis.com/css2?family=Simonetta:ital,wght@0,400;0,900;1,400&display=swap');
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
          body { font-family: 'Inter', sans-serif; }
        `
      }} />

      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-slate-200">
        <div className="max-w-[640px] md:max-w-[960px] lg:max-w-[1140px] mx-auto px-[18px] flex items-center justify-between h-[64px]">
          <div className="flex items-center gap-[9px] font-extrabold text-slate-950 text-[1.1rem] font-['Simonetta',serif]">
            <img src={clinicLogo} alt="Kosmix Dental Clinic" style={{ height: '48px', objectFit: 'contain' }} />
            <span className="flex flex-col text-[0.95rem] leading-[1.2]">
              <span>Kosmix</span>
              <span>Dental Clinic</span>
            </span>
          </div>
          <a className="hidden md:inline-flex items-center gap-[6px] bg-teal-100 text-teal-700 font-extrabold text-[0.85rem] px-[14px] py-[10px] rounded-[10px] font-['Simonetta',serif] uppercase tracking-[0.05em]" href="tel:+919035289171">
            <FaPhoneAlt className="text-[1rem] -mt-[2px]" /> Call
          </a>
        </div>
      </header>

      {/* HERO — FORM ABOVE THE FOLD */}
      <section className="text-white pt-[48px] pb-[40px] min-h-screen flex items-center bg-cover bg-center" style={{ background: `linear-gradient(rgba(2,6,23,0.4),rgba(15,23,42,0.5)),url('${clinicBg}') center/cover` }}>
        <div className="max-w-[640px] md:max-w-[960px] lg:max-w-[1140px] mx-auto px-[18px] flex flex-col md:grid md:grid-cols-2 gap-[40px] md:gap-[48px] md:items-center">
          <div>
            <span className="inline-block text-[0.75rem] font-extrabold tracking-[0.12em] uppercase text-teal-100 mb-[8px] font-['Simonetta',serif]">Dentist Near Me · HSR Layout, Bengaluru</span>
            <h1 className="text-white font-['Simonetta',serif] text-[2rem] md:text-[3.5rem] font-extrabold leading-[1.15] tracking-[-0.02em] mb-[12px]">Searching for a Dental Clinic Near Me?</h1>
            <p className="text-white text-[1rem] md:text-[1.125rem] mb-[12px] font-normal leading-relaxed">
              You've Found It. Kosmix Dental Clinic is HSR Layout's trusted Dental Clinic for painless root canals, implants & smile makeovers.
            </p>
            <div className="text-[0.9rem] font-semibold my-[16px] md:mb-[24px] leading-relaxed">
              <span className="text-[#F5A623] mr-[6px]">★★★★★</span> <span>4.9 · 500+ Google reviews · 500+ patients · Open till 11:00 PM</span>
            </div>
            <div className="flex flex-wrap gap-[10px] justify-start mt-[20px]">
              <span className="bg-white/12 text-white text-[0.85rem] font-semibold px-[12px] py-[8px] rounded-[8px]">✓ Same-day appointments</span>
              <span className="bg-white/12 text-white text-[0.85rem] font-semibold px-[12px] py-[8px] rounded-[8px]">✓ UPI & cards</span>
              <span className="bg-white/12 text-white text-[0.85rem] font-semibold px-[12px] py-[8px] rounded-[8px]">✓ Street parking</span>
            </div>
            <div className="grid grid-cols-2 gap-[12px] mt-[24px]">
              <a className="inline-flex items-center justify-center gap-[8px] font-extrabold text-base px-[18px] py-[15px] rounded-[13px] w-full transition-transform duration-100 hover:scale-[0.99] active:translate-y-[1px] uppercase tracking-[0.05em] font-['Simonetta',serif] bg-teal-600 text-white hover:bg-teal-700" href="tel:+919035289171">
                <FaPhoneAlt className="text-[1rem] -mt-[2px]" /> Call
              </a>
              <a
                className="inline-flex items-center justify-center gap-[8px] font-extrabold text-base px-[18px] py-[15px] rounded-[13px] w-full transition-transform duration-100 hover:scale-[0.99] active:translate-y-[1px] uppercase tracking-[0.05em] font-['Simonetta',serif] bg-[#25D366] text-white hover:bg-[#1EBE5B]"
                href="https://wa.me/919035289171?text=Hi%2C%20I%27d%20like%20to%20book%20a%20dental%20appointment"
              >
                <FaWhatsapp className="text-[1.2rem] -mt-[2px]" /> WhatsApp
              </a>
            </div>
          </div>
          <div className="bg-white rounded-[24px] p-[24px] shadow-[0_20px_50px_rgba(0,0,0,0.3)] text-slate-800">
            <h3 className="font-['Simonetta',serif] text-slate-950 text-[1.25rem] md:text-[1.35rem] font-extrabold leading-[1.15] tracking-[-0.02em] mb-[4px]">Request a callback</h3>
            <div className="text-slate-500 text-[0.95rem] mb-[20px] font-normal">Tell us when — we'll confirm on WhatsApp within the hour.</div>

            {!formSubmitted ? (
              <form id="bf" noValidate onSubmit={handleSubmit}>
                <div className="mb-[16px]">
                  <label className="block text-[0.85rem] font-semibold text-slate-950 mb-[6px] font-['Simonetta',serif] uppercase tracking-[0.05em]">Name</label>
                  <input className="w-full p-[14px_16px] border-[1.5px] border-slate-200 rounded-xl text-[1.05rem] bg-slate-50 text-slate-800 focus:border-teal-600 focus:bg-white focus:outline-none max-w-full" name="name" autoComplete="name" placeholder="Your name" required onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '')} />
                </div>
                <div className="mb-[16px]">
                  <label className="block text-[0.85rem] font-semibold text-slate-950 mb-[6px] font-['Simonetta',serif] uppercase tracking-[0.05em]">Phone / WhatsApp</label>
                  <input className="w-full p-[14px_16px] border-[1.5px] border-slate-200 rounded-xl text-[1.05rem] bg-slate-50 text-slate-800 focus:border-teal-600 focus:bg-white focus:outline-none max-w-full" name="phone" type="tel" autoComplete="tel" placeholder="Your number" required maxLength={10} onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')} />
                </div>
                <div className="mb-[16px] relative">
                  <label className="block text-[0.85rem] font-semibold text-slate-950 mb-[6px] font-['Simonetta',serif] uppercase tracking-[0.05em]">Treatment needed</label>
                  <input type="hidden" name="treatment" value={selectedTreatment} />
                  <div
                    className="w-full p-[14px_16px] border-[1.5px] border-slate-200 rounded-xl text-[1.05rem] bg-slate-50 text-slate-800 cursor-pointer flex justify-between items-center select-none max-w-full"
                    onClick={() => setTreatmentOpen(!treatmentOpen)}
                  >
                    <span className="overflow-hidden text-ellipsis whitespace-nowrap">
                      {selectedTreatment || "Select a treatment"}
                    </span>
                    <span className="text-slate-500">▾</span>
                  </div>
                  {treatmentOpen && (
                    <>
                      <div
                        className="fixed inset-0 z-[99]"
                        onClick={() => setTreatmentOpen(false)}
                      />
                      <div className="absolute top-full left-0 right-0 bg-white border-[1.5px] border-slate-200 rounded-xl mt-[4px] max-h-[240px] overflow-y-auto z-[100] shadow-[0_6px_22px_rgba(2,6,23,0.09)]">
                        {treatments.map(t => (
                          <div
                            key={t}
                            className="p-[12px_16px] text-[1.05rem] text-slate-800 cursor-pointer border-b border-slate-200 transition-colors duration-200 last:border-b-0 hover:bg-slate-50 hover:text-teal-600"
                            onClick={() => {
                              setSelectedTreatment(t);
                              setTreatmentOpen(false);
                            }}
                          >
                            {t}
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
                <button className="inline-flex items-center justify-center gap-[8px] font-extrabold text-base px-[18px] py-[15px] rounded-[13px] w-full transition-transform duration-100 hover:scale-[0.99] active:translate-y-[1px] uppercase tracking-[0.05em] font-['Simonetta',serif] bg-teal-600 text-white hover:bg-teal-700" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Submitting...' : 'Request my appointment'}
                </button>
              </form>
            ) : (
              <div className="bg-teal-100 rounded-xl p-[20px] text-center text-teal-700 font-bold block" id="ok">
                ✓ Got it! We'll reach out on WhatsApp shortly.
              </div>
            )}

          </div>
        </div>
      </section>

      {/* GALLERY */}
      <section className="py-[32px]" style={{ background: 'linear-gradient(to right, #f3e9dc, #fff)' }}>
        <div className="max-w-[640px] md:max-w-[960px] lg:max-w-[1140px] mx-auto px-[18px]">
          <div className="flex justify-between items-center flex-wrap gap-[16px] mb-[16px]">
            <div>
              <span className="inline-block text-[0.75rem] font-extrabold tracking-[0.12em] uppercase text-teal-600 mb-[8px] font-['Simonetta',serif]">Real results</span>
              <h2 className="font-['Simonetta',serif] text-slate-950 text-[2rem] font-extrabold leading-[1.15] tracking-[-0.02em] mb-0">Smiles That Speak for Themselves!</h2>
            </div>
            <div className="flex gap-[8px]">
              <button onClick={() => scrollGal('left')} aria-label="Previous" className="bg-white border border-slate-200 rounded-full w-[36px] h-[36px] cursor-pointer flex items-center justify-center text-slate-800 hover:bg-slate-50 transition-colors">←</button>
              <button onClick={() => scrollGal('right')} aria-label="Next" className="bg-white border border-slate-200 rounded-full w-[36px] h-[36px] cursor-pointer flex items-center justify-center text-slate-800 hover:bg-slate-50 transition-colors">→</button>
            </div>
          </div>
          <div className="flex gap-[12px] overflow-x-auto snap-x snap-mandatory py-[20px] pb-[10px] scrollbar-hide" ref={galRef}>
            {[1, 2, 3, 4, 5, 6].map((num) => (
              <div key={num} className="flex-[0_0_70%] md:flex-[0_0_40%] lg:flex-[0_0_23.5%] snap-start rounded-[16px] overflow-hidden border border-slate-200 bg-slate-50 flex items-center justify-center">
                <img
                  src={`/lp_ppc1/img${num}.jpeg`}
                  alt={`Patient Success ${num}`}
                  className="w-full h-full max-h-[400px] object-cover"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROOF RIBBON */}
      <div className="">
        <div className="max-w-[640px] md:max-w-[960px] lg:max-w-[1140px] mx-auto px-[18px] grid grid-cols-2 lg:grid-cols-4 gap-[12px] py-[32px]">
          <div className="bg-white border border-slate-200 rounded-[16px] p-[16px_10px] md:p-[20px] text-center shadow-[0_6px_22px_rgba(2,6,23,0.09)] flex flex-col justify-center h-full">
            <div className="text-[1.35rem] md:text-[1.75rem] font-extrabold text-teal-600 leading-[1.1] font-['Simonetta',serif]">Since 2018</div>
            <div className="text-[0.75rem] md:text-[0.85rem] text-slate-500 mt-[4px] font-bold uppercase tracking-[0.02em] md:tracking-[0.05em] leading-[1.3]">Trusted Clinic</div>
          </div>
          <div className="bg-white border border-slate-200 rounded-[16px] p-[16px_10px] md:p-[20px] text-center shadow-[0_6px_22px_rgba(2,6,23,0.09)] flex flex-col justify-center h-full">
            <div className="text-[1.35rem] md:text-[1.75rem] font-extrabold text-teal-600 leading-[1.1] font-['Simonetta',serif]">5,000+</div>
            <div className="text-[0.75rem] md:text-[0.85rem] text-slate-500 mt-[4px] font-bold uppercase tracking-[0.02em] md:tracking-[0.05em] leading-[1.3]">Happy Smiles</div>
          </div>
          <div className="bg-white border border-slate-200 rounded-[16px] p-[16px_10px] md:p-[20px] text-center shadow-[0_6px_22px_rgba(2,6,23,0.09)] flex flex-col justify-center h-full">
            <div className="text-[1.35rem] md:text-[1.75rem] font-extrabold text-teal-600 leading-[1.1] font-['Simonetta',serif]">Same-Day</div>
            <div className="text-[0.75rem] md:text-[0.85rem] text-slate-500 mt-[4px] font-bold uppercase tracking-[0.02em] md:tracking-[0.05em] leading-[1.3]">Crowns & RCT</div>
          </div>
          <div className="bg-white border border-slate-200 rounded-[16px] p-[16px_10px] md:p-[20px] text-center shadow-[0_6px_22px_rgba(2,6,23,0.09)] flex flex-col justify-center h-full">
            <div className="text-[1.35rem] md:text-[1.75rem] font-extrabold text-teal-600 leading-[1.1] font-['Simonetta',serif]">100+</div>
            <div className="text-[0.75rem] md:text-[0.85rem] text-slate-500 mt-[4px] font-bold uppercase tracking-[0.02em] md:tracking-[0.05em] leading-[1.3]">5-Star Reviews</div>
          </div>
        </div>
      </div>



      {/* SERVICES */}
      <section className="py-[8px]">
        <div className="max-w-[640px] md:max-w-[960px] lg:max-w-[1140px] mx-auto px-[18px]">
          <span className="inline-block text-[0.75rem] font-extrabold tracking-[0.12em] uppercase text-teal-600 mb-[8px] font-['Simonetta',serif]">Our services</span>
          <h2 className="font-['Simonetta',serif] text-slate-950 text-[2rem] font-extrabold leading-[1.15] tracking-[-0.02em] mb-[8px]">Complete Dental Care in HSR Layout</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-[16px] mt-[24px] auto-rows-fr">
            {[
              { i: <FaTooth />, b: "Dental Implants", s: "3D-Guided", p: "Permanent, natural-looking tooth replacements to restore your smile." },
              { i: <FaStethoscope />, b: "Painless RCT", s: "One Visit", p: "Save your natural tooth with our gentle, quick root canal treatments." },
              { i: <FaCrown />, b: "Crowns & Bridges", s: "Natural-Looking", p: "Strengthen damaged teeth and fill gaps seamlessly with durable materials." },
              { i: <FaSmile />, b: "Braces & Aligners", s: "Clear Options", p: "Straighten your teeth effectively with traditional braces or invisible aligners." },
              { i: <FaMagic />, b: "Whitening & Veneers", s: "Smile Design", p: "Instantly brighten your teeth and fix imperfections for a flawless look." },
              { i: <FaChild />, b: "Kids & Family", s: "Gentle Care", p: "Compassionate, stress-free dental care designed for patients of all ages." },
              { i: <FaSyringe />, b: "Tooth Extraction", s: "Wisdom Tooth", p: "Safe, painless extractions with quick recovery and clear aftercare guidance." },
              { i: <FaTint />, b: "Teeth Cleaning & Scaling", s: "Fresh in 30 Min", p: "Remove plaque, tartar and stains for fresher breath and healthier gums." },
              { i: <FaLeaf />, b: "Gum Care & Laser Treatment", s: "LANAP Specialty", p: "Advanced laser treatments for healthy gums and periodontics." },
              { i: <FaWrench />, b: "Full Mouth Rehabilitation", s: "Complete Restore", p: "Rebuild function and aesthetics with a fully personalised treatment plan." },
              { i: <FaGrin />, b: "Dentures", s: "Custom-Fit", p: "High-quality, comfortable removable replacements for missing teeth." },
              { i: <FaAmbulance />, b: "Emergency Dental Care", s: "Same-Day Relief", p: "Immediate dental care for toothaches, trauma, and other urgent needs." },
            ].map(svc => (
              <div key={svc.b} className="bg-white border border-slate-200 rounded-[12px] p-[8px_4px] md:p-[12px_10px] flex flex-col items-center text-center justify-center h-full min-h-[80px]">
                <div className="flex flex-col items-center text-center gap-[4px] md:gap-[6px] mb-0">
                  <div className="text-[1.5rem] md:text-[1.75rem] leading-none text-teal-600">{svc.i}</div>
                  <b className="text-slate-950 text-[0.85rem] md:text-[1rem] font-['Simonetta',serif] leading-[1.1] md:leading-[1.2]">{svc.b}</b>
                </div>
                <span className="hidden md:inline-block text-teal-600 text-[0.8rem] font-bold uppercase tracking-[0.05em] mt-[4px]">{svc.s}</span>
                <p className="hidden md:block text-slate-500 text-[0.95rem] leading-[1.5] mt-[10px]">{svc.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* DENTIST */}
      {/* DENTIST */}
      <section className="py-[8px]">
        <div className="max-w-[640px] md:max-w-[960px] lg:max-w-[1140px] mx-auto px-[18px]">
          <span className="inline-block text-[0.75rem] font-extrabold tracking-[0.12em] uppercase text-teal-600 mb-[8px] font-['Simonetta',serif]">Your dentists</span>
          <h2 className="font-['Simonetta',serif] text-slate-950 text-[2rem] font-extrabold leading-[1.15] tracking-[-0.02em] mb-[8px]">Meet Our Expert Doctors</h2>

          <div className="mt-[24px] grid grid-cols-1 md:grid-cols-2 gap-[16px] md:gap-[24px]">

            {/* Doctor 1 Card */}
            <div className="flex flex-col gap-[16px] bg-white rounded-[24px] p-[16px] md:p-[24px] shadow-[0_20px_50px_rgba(2,6,23,0.08)] border border-slate-200 items-center">
              <div className="relative p-[12px] w-full max-w-[320px] mx-auto">
                <div className="absolute inset-0 rounded-[24px] z-0 -rotate-2 bg-gradient-to-br from-teal-100 to-teal-200"></div>
                <img src={shahImg?.src || shahImg} alt="Dr. Shankhadeep Saha" className="relative z-10 w-full aspect-[10/9] object-cover object-top rounded-[16px] shadow-[0_16px_32px_rgba(0,0,0,0.15)]" />
              </div>
              <div className="py-[8px] w-full">
                <div className="flex flex-wrap gap-[6px] mb-[12px]">
                  <span className="bg-slate-950 text-white px-[12px] py-[4px] rounded-[8px] text-[0.75rem] font-extrabold uppercase tracking-[0.05em]">Periodontics</span>
                  <span className="bg-teal-100 text-teal-700 px-[12px] py-[4px] rounded-[8px] text-[0.75rem] font-extrabold uppercase tracking-[0.05em]">Implantology</span>
                </div>
                <h3 className="font-['Simonetta',serif] text-slate-950 text-[1.75rem] font-extrabold leading-[1.1] mb-[8px]">Dr. Shankhadeep Saha</h3>
                <p className="text-slate-500 text-[0.95rem] leading-[1.5] mb-[16px]">
                  With over 9 years of clinical expertise, Dr. Shankhadeep Saha is a distinguished Periodontist & Implantologist in HSR Layout. Known for his gentle approach, he specializes in laser dentistry and full mouth rehabilitation, delivering cutting-edge, painless treatments to restore both function and aesthetics.
                </p>
                <div className="grid grid-cols-2 gap-[12px]">
                  <div className="flex items-center gap-[8px]">
                    <div className="w-[36px] h-[36px] rounded-[10px] grid place-items-center text-[1rem] shrink-0 bg-teal-600/10 text-teal-600">✨</div>
                    <b className="text-slate-950 text-[0.85rem] leading-[1.2]">Periodontics & Implants</b>
                  </div>
                  <div className="flex items-center gap-[8px]">
                    <div className="w-[36px] h-[36px] rounded-[10px] grid place-items-center text-[1rem] shrink-0 bg-teal-600/10 text-teal-600">⚡</div>
                    <b className="text-slate-950 text-[0.85rem] leading-[1.2]">Painless RCT</b>
                  </div>
                  <div className="flex items-center gap-[8px]">
                    <div className="w-[36px] h-[36px] rounded-[10px] grid place-items-center text-[1rem] shrink-0 bg-teal-600/10 text-teal-600">🔦</div>
                    <b className="text-slate-950 text-[0.85rem] leading-[1.2]">Laser Dentistry</b>
                  </div>
                  <div className="flex items-center gap-[8px]">
                    <div className="w-[36px] h-[36px] rounded-[10px] grid place-items-center text-[1rem] shrink-0 bg-teal-600/10 text-teal-600">🦷</div>
                    <b className="text-slate-950 text-[0.85rem] leading-[1.2]">Full Mouth Rehab</b>
                  </div>
                </div>
              </div>
            </div>

            {/* Doctor 2 Card */}
            <div className="flex flex-col gap-[16px] bg-white rounded-[24px] p-[16px] md:p-[24px] shadow-[0_20px_50px_rgba(2,6,23,0.08)] border border-slate-200 items-center">
              <div className="relative p-[12px] w-full max-w-[320px] mx-auto">
                <div className="absolute inset-0 rounded-[24px] z-0 rotate-2 bg-gradient-to-br from-slate-200 to-slate-300"></div>
                <img src="/lp_ppc1/Saul.jpeg" alt="Dr. Sophia Saud" className="relative z-10 w-full aspect-[10/9] object-cover object-top rounded-[16px] shadow-[0_16px_32px_rgba(0,0,0,0.15)]" />
              </div>
              <div className="py-[8px] w-full">
                <div className="flex flex-wrap gap-[6px] mb-[12px]">
                  <span className="bg-slate-800 text-white px-[12px] py-[4px] rounded-[8px] text-[0.75rem] font-extrabold uppercase tracking-[0.05em]">Endodontist</span>
                  <span className="bg-slate-100 text-slate-700 px-[12px] py-[4px] rounded-[8px] text-[0.75rem] font-extrabold uppercase tracking-[0.05em]">Aesthetic Specialist</span>
                </div>
                <h3 className="font-['Simonetta',serif] text-slate-950 text-[1.75rem] font-extrabold leading-[1.1] mb-[8px]">Dr. Sophia Saud</h3>
                <p className="text-slate-500 text-[0.95rem] leading-[1.5] mb-[16px]">
                  Dr. Sophia Saud is a highly skilled Endodontist & Aesthetic Specialist dedicated to delivering the highest standard of care. With expertise in single-visit root canals, laser dentistry, and smile designing, she ensures every visit is a positive, stress-free experience with flawless, natural-looking results.
                </p>
                <div className="grid grid-cols-2 gap-[12px]">
                  <div className="flex items-center gap-[8px]">
                    <div className="w-[36px] h-[36px] rounded-[10px] grid place-items-center text-[1rem] shrink-0 bg-slate-100 text-slate-800">💎</div>
                    <b className="text-slate-950 text-[0.85rem] leading-[1.2]">Smile Designing</b>
                  </div>
                  <div className="flex items-center gap-[8px]">
                    <div className="w-[36px] h-[36px] rounded-[10px] grid place-items-center text-[1rem] shrink-0 bg-slate-100 text-slate-800">⚡</div>
                    <b className="text-slate-950 text-[0.85rem] leading-[1.2]">Expert in RCTs</b>
                  </div>
                  <div className="flex items-center gap-[8px]">
                    <div className="w-[36px] h-[36px] rounded-[10px] grid place-items-center text-[1rem] shrink-0 bg-slate-100 text-slate-800">🔦</div>
                    <b className="text-slate-950 text-[0.85rem] leading-[1.2]">Laser Procedures</b>
                  </div>
                  <div className="flex items-center gap-[8px]">
                    <div className="w-[36px] h-[36px] rounded-[10px] grid place-items-center text-[1rem] shrink-0 bg-slate-100 text-slate-800">🛡️</div>
                    <b className="text-slate-950 text-[0.85rem] leading-[1.2]">Veneers</b>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* LOCATION */}
      <section id="location" className="py-[8px]">
        <div className="max-w-[640px] md:max-w-[960px] lg:max-w-[1140px] mx-auto px-[18px]">
          <span className="inline-block text-[0.75rem] font-extrabold tracking-[0.12em] uppercase text-teal-600 mb-[8px] font-['Simonetta',serif]">Find us</span>
          <h2 className="font-['Simonetta',serif] text-slate-950 text-[2rem] font-extrabold leading-[1.15] tracking-[-0.02em] mb-[8px]">Dental Clinic in HSR Layout, Bengaluru</h2>
          <div className="grid grid-cols-1 md:grid-cols-[1.5fr_1fr] gap-[32px] md:gap-[48px] mt-[24px] md:items-center">
            <div className="rounded-[24px] overflow-hidden border border-slate-200 aspect-[4/3] md:aspect-[16/10] bg-slate-50">
              <iframe
                title="Kosmix Dental Clinic Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.9989629433803!2d77.6485828!3d12.907787899999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae149953a107f5%3A0xdb63ec5c78e614!2sKosmix%20Dental%20Clinic!5e0!3m2!1sen!2sin!4v1737028890133!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="grid gap-[16px] content-center">
              <div className="flex gap-[14px] items-start">
                <span className="text-[1.5rem] shrink-0">📍</span>
                <div>
                  <b className="block text-slate-950 text-[1.05rem] font-['Simonetta',serif]">Address</b>
                  <span className="text-slate-500 text-[0.95rem]">1175, 24th Main Rd, near Shri Maramma Devi Devasthana, Garden Layout, Sector 2, HSR Layout, Bengaluru, Karnataka 560102</span>
                </div>
              </div>
              <div className="flex gap-[14px] items-start">
                <span className="text-[1.5rem] shrink-0">🕙</span>
                <div>
                  <b className="block text-slate-950 text-[1.05rem] font-['Simonetta',serif]">Working Hours</b>
                  <span className="text-slate-500 text-[0.95rem]">Monday to Sunday<br />10:00 AM - 11:00 PM</span>
                </div>
              </div>
              <div className="flex gap-[14px] items-start">
                <span className="text-[1.5rem] shrink-0">📞</span>
                <div>
                  <b className="block text-slate-950 text-[1.05rem] font-['Simonetta',serif]">Contact Us</b>
                  <span className="text-slate-500 text-[0.95rem]">
                    <a href="tel:+919035289171" className="text-inherit hover:text-teal-600 transition-colors">9035289171</a><br />
                    <a href="tel:08042083115" className="text-inherit hover:text-teal-600 transition-colors">080 4208 3115</a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* REVIEWS */}
      <section className="py-[32px] md:py-[48px] overflow-hidden">
        <div className="max-w-[640px] md:max-w-[960px] lg:max-w-[1140px] mx-auto px-[18px]">
          <Testimonial />
        </div>
      </section>

      {/* FAQ */}
      <section className="py-[48px]" style={{ background: 'linear-gradient(to right, #f3e9dc, #fff)' }}>
        <div className="max-w-[640px] md:max-w-[760px] mx-auto px-[18px]">
          <div className="text-center mb-[40px]">
            <span className="inline-block text-[0.75rem] font-extrabold tracking-[0.12em] uppercase text-teal-600 mb-[8px] font-['Simonetta',serif]">Good to know</span>
            <h2 className="font-['Simonetta',serif] text-slate-950 text-[2.2rem] font-extrabold leading-[1.15] tracking-[-0.02em] mb-0">FAQs</h2>
          </div>
          <div className="flex flex-col gap-[16px]">
            <details name="faq" className="group bg-slate-50 border border-slate-200 rounded-[16px] overflow-hidden [&_summary::-webkit-details-marker]:hidden" open>
              <summary className="flex justify-between items-center cursor-pointer p-[20px] font-extrabold text-slate-950 text-[1.1rem]">
                How quickly will you respond to my form?
                <span className="transition duration-300 group-open:-rotate-180 text-teal-600 text-[1.2rem]">▾</span>
              </summary>
              <div className="px-[20px] pb-[20px] text-slate-600 leading-[1.6] text-[1.05rem]">
                Usually within the hour during clinic hours (10:00 AM – 11:00 PM). You can also WhatsApp us for an instant reply.
              </div>
            </details>
            <details name="faq" className="group bg-slate-50 border border-slate-200 rounded-[16px] overflow-hidden [&_summary::-webkit-details-marker]:hidden">
              <summary className="flex justify-between items-center cursor-pointer p-[20px] font-extrabold text-slate-950 text-[1.1rem]">
                Are you near me in HSR Layout?
                <span className="transition duration-300 group-open:-rotate-180 text-teal-600 text-[1.2rem]">▾</span>
              </summary>
              <div className="px-[20px] pb-[20px] text-slate-600 leading-[1.6] text-[1.05rem]">
                We're at 1175, 24th Main Rd, near Shri Maramma Devi Devasthana, Garden Layout, Sector 2, HSR Layout, Bengaluru. Street parking is available right outside.
              </div>
            </details>
            <details name="faq" className="group bg-slate-50 border border-slate-200 rounded-[16px] overflow-hidden [&_summary::-webkit-details-marker]:hidden">
              <summary className="flex justify-between items-center cursor-pointer p-[20px] font-extrabold text-slate-950 text-[1.1rem]">
                Will the treatment hurt?
                <span className="transition duration-300 group-open:-rotate-180 text-teal-600 text-[1.2rem]">▾</span>
              </summary>
              <div className="px-[20px] pb-[20px] text-slate-600 leading-[1.6] text-[1.05rem]">
                Comfort comes first. We use modern anaesthesia and gentle techniques for painless root canals, extractions and implants. Most patients are surprised by how relaxed the visit feels.
              </div>
            </details>
            <details name="faq" className="group bg-slate-50 border border-slate-200 rounded-[16px] overflow-hidden [&_summary::-webkit-details-marker]:hidden">
              <summary className="flex justify-between items-center cursor-pointer p-[20px] font-extrabold text-slate-950 text-[1.1rem]">
                Do you offer same-day or emergency appointments?
                <span className="transition duration-300 group-open:-rotate-180 text-teal-600 text-[1.2rem]">▾</span>
              </summary>
              <div className="px-[20px] pb-[20px] text-slate-600 leading-[1.6] text-[1.05rem]">
                Yes. We keep slots open for urgent pain, broken teeth and swelling. Call or WhatsApp us and we'll fit you in the same day whenever possible.
              </div>
            </details>
            <details name="faq" className="group bg-slate-50 border border-slate-200 rounded-[16px] overflow-hidden [&_summary::-webkit-details-marker]:hidden">
              <summary className="flex justify-between items-center cursor-pointer p-[20px] font-extrabold text-slate-950 text-[1.1rem]">
                How much does a root canal or implant cost?
                <span className="transition duration-300 group-open:-rotate-180 text-teal-600 text-[1.2rem]">▾</span>
              </summary>
              <div className="px-[20px] pb-[20px] text-slate-600 leading-[1.6] text-[1.05rem]">
                It depends on the tooth and materials, so we give you a clear, written estimate after a quick exam — no surprises. Ask us about EMI options to split the cost of larger treatments.
              </div>
            </details>
          </div>
        </div>
      </section>

      <footer className="bg-slate-950 text-slate-300 py-[48px] pb-[100px] md:pb-[48px]">
        <div className="max-w-[640px] md:max-w-[960px] lg:max-w-[1140px] mx-auto px-[18px] flex flex-col md:flex-row justify-between items-start gap-[40px]">
          <div>
            <div className="flex items-center gap-[12px] mb-[20px]">
              <img src={clinicLogo} alt="Kosmix Dental Clinic" className="h-[44px] object-contain bg-white p-[6px] rounded-[8px] shrink-0" />
              <span className="font-['Simonetta',serif] text-white text-[1.2rem] font-extrabold">Kosmix Dental Clinic</span>
            </div>
            <div className="text-[0.95rem] leading-[1.7] max-w-[400px]">
              1175, 24th Main Rd, near Shri Maramma Devi Devasthana, Garden Layout, Sector 2, HSR Layout, Bengaluru, Karnataka 560102<br />
              <a href="tel:+919035289171" className="text-teal-400 hover:text-teal-300 transition-colors font-semibold">9035289171</a> <span className="mx-2 opacity-50">·</span> <a href="tel:08042083115" className="text-teal-400 hover:text-teal-300 transition-colors font-semibold">080 4208 3115</a><br />
              Monday to Sunday 10:00 AM - 11:00 PM
            </div>
          </div>
          <div className="shrink-0 flex items-center justify-center w-full md:w-auto md:justify-start flex-wrap gap-[12px] mt-[24px] md:mt-[16px]">
            <a href="https://mastermindweb.in/" target="_blank" rel="noopener noreferrer" className="opacity-80 hover:opacity-100 transition-opacity">
              <img src={mastermindLogo} alt="Mastermind Web Developers" className="h-[70px] md:h-[90px] w-auto object-contain mx-auto" loading="lazy" />
            </a>
          </div>
        </div>
      </footer>

      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-50 flex md:hidden shadow-[0_-4px_20px_rgba(0,0,0,0.05)]" aria-label="Quick actions">
        <a href="tel:+919035289171" className="flex-1 flex flex-col items-center justify-center pt-[12px] pb-[calc(12px+env(safe-area-inset-bottom,0px))] gap-[4px] text-slate-600 hover:text-teal-600 hover:bg-slate-50 transition-colors">
          <svg className="w-[22px] h-[22px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#16a34a"><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" /></svg>
          <span className="text-[0.65rem] font-bold uppercase tracking-wider">Phone</span>
        </a>
        <a href="https://maps.google.com/?q=Kosmix+Dental+Clinic+HSR+Layout" target="_blank" rel="noreferrer" className="flex-1 flex flex-col items-center justify-center pt-[12px] pb-[calc(12px+env(safe-area-inset-bottom,0px))] gap-[4px] text-slate-600 hover:text-teal-600 hover:bg-slate-50 transition-colors border-l border-slate-100">
          <svg className="w-[22px] h-[22px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0d9488"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z" /></svg>
          <span className="text-[0.65rem] font-bold uppercase tracking-wider">Address</span>
        </a>
        <a href="https://wa.me/919035289171?text=Hi%2C%20I%27d%20like%20to%20book%20a%20dental%20appointment" className="flex-1 flex flex-col items-center justify-center pt-[12px] pb-[calc(12px+env(safe-area-inset-bottom,0px))] gap-[4px] text-slate-600 hover:text-teal-600 hover:bg-slate-50 transition-colors border-l border-slate-100">
          <svg className="w-[22px] h-[22px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#25D366"><path d="M12.01 2.01c-5.5 0-9.98 4.47-9.98 9.97 0 1.98.58 3.82 1.58 5.37L2 22l4.82-1.57c1.48.92 3.23 1.45 5.09 1.45 5.5 0 9.98-4.47 9.98-9.97 0-5.5-4.48-9.97-9.98-9.97zM17.43 16.48c-.28.8-1.59 1.53-2.22 1.63-.56.09-1.28.25-3.66-.73-2.88-1.18-4.73-4.14-4.87-4.32-.14-.19-1.17-1.55-1.17-2.96 0-1.4.74-2.09 1-2.37.26-.28.56-.35.75-.35.19 0 .37 0 .54.01.19.01.44-.07.67.5.24.58.78 1.93.85 2.06.07.14.12.3.02.5-.09.19-.14.3-.28.46-.14.16-.3.35-.42.48-.14.14-.29.29-.12.58.17.29.74 1.22 1.59 1.98.99.88 1.9 1.15 2.19 1.29.28.14.45.12.62-.07.17-.19.74-.85.94-1.15.19-.3.39-.25.65-.15.26.1 1.66.78 1.94.92.28.14.47.21.54.33.07.12.07.72-.21 1.52z" /></svg>
          <span className="text-[0.65rem] font-bold uppercase tracking-wider">WhatsApp</span>
        </a>
      </nav>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Dentist",
            "name": "Kosmix Dental Clinic",
            "telephone": "+919035289171",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "1175, 24th Main Rd, near Shri Maramma Devi Devasthana, Garden Layout, Sector 2, HSR Layout",
              "addressLocality": "Bengaluru",
              "addressRegion": "Karnataka",
              "postalCode": "560102",
              "addressCountry": "IN"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 13.0240,
              "longitude": 77.6923
            },
            "openingHours": "Mo-Su 10:00-21:30",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.9",
              "reviewCount": "26"
            },
            "priceRange": "₹₹"
          })
        }}
      />
    </>
  );
}
